export enum TestAttribute {
  SelectContainer = 'select-container',
  SelectOptions = 'select-options',
  Card = 'card',
}
